import React from 'react';

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[RouteErrorBoundary] Render error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="min-h-[40vh] flex items-center justify-center bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200">
            <div className="text-center space-y-2">
              <p className="text-lg font-semibold">Algo salio mal.</p>
              <p className="text-sm">Recarga la pagina e intenta de nuevo.</p>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
